var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineShieldSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.98 21.81-1.59-1.19a.75.75 0 0 1 .9-1.2l1.59 1.19c1.15.86 3.1.86 4.25 0l4.3-3.21c.76-.57 1.42-1.9 1.42-2.84V7.12c0-.41.34-.75.75-.75s.75.34.75.75v7.43c0 1.42-.89 3.19-2.03 4.04l-4.3 3.21c-.85.64-1.93.96-3.02.96s-2.17-.32-3.02-.95zM4.88 18.75l-.2-.15c-1.14-.85-2.03-2.63-2.03-4.04V7.12c0-1.54 1.13-3.18 2.58-3.72l4.99-1.87c.99-.37 2.55-.37 3.54 0l5 1.87c.21.08.41.18.61.3a.747.747 0 1 1-.79 1.27c-.11-.07-.22-.13-.34-.17l-5-1.87c-.66-.25-1.83-.25-2.49 0L5.76 4.81c-.86.32-1.61 1.4-1.61 2.32v7.43c0 .95.67 2.28 1.42 2.84l.2.15c.33.25.4.72.15 1.05a.72.72 0 0 1-.59.3.76.76 0 0 1-.45-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineShieldSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-shield-slash.295ed81b70f9ebbdb82d80d246387b43.svg";
export { ForwardRef as ReactComponent };